import React, { FC } from 'react';
import { Popup } from 'devextreme-react/popup';
import { ActionButton, HeadingItem } from 'components';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons'
import './stamped-delivery-receipt-popup.scss';
import { ButtonDetails } from 'types'

type Props = {
    isVisible: boolean,
    title: string,
    message: string,
    button: ButtonDetails,
    onClickButton: () => void,
}

export const StampedDeliveryReceiptPopup: FC<Props> = ({ isVisible, title, message, button, onClickButton }) => {

    return (
        <Popup
            visible={isVisible}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showTitle={false}
            width = {300}
            height={250}

        >
            <div className="stamped-delivery-receipt-popup-card">
                <HeadingItem 
                    text={title}
                />
                <div className={'stamped-delivery-receipt-popup-content'}>{message}</div>
                <div className={'bottom-fix-action-row'}>
                    <ActionButton 
                        icon={button.icon}
                        buttonColor={button.backgroundColor ? button.backgroundColor : '#82BC24'}
                        onClick={onClickButton}
                        buttonText={button.text ?? 'Ok'}
                    />
                </div>
            </div>
        </Popup>
    )
}